<template>
	<div class="formatUSPhone" @click="onCopyToClipboard(formatUSPhone)">{{ formatUSPhone }}</div>
</template>

<script>
import { getFormatUSPhone } from "@/helper/getFormatUSPhone";
import { mapActions } from "vuex";

export default {
	name: "PhoneUSA",
	props: {
		item: Object,
		line: Object
	},
	data() {
		return {
			formatUSPhone: null,
		};
	},
	methods: {
		...mapActions([
			"setAlert",
		]),
		setFormatUSPhone() {
			this.formatUSPhone = getFormatUSPhone(this.line[this.item.value]);
		},
		onCopyToClipboard(text) {
			navigator.clipboard.writeText(text).then(() => {
				this.setAlert({ type: "success", message: `📋 Phone number copied successfully. [ <b>${ text }</b> ]` });
			}).catch((err) => {
				console.error('Could not copy text: ', err);
				this.setAlert({ type: "error", message: 'Whoops, something went wrong! 🙁' });
			});
		},
	},
	mounted() {
		this.setFormatUSPhone();
	}
};
</script>

<style scoped lang="scss">
.formatUSPhone {
	width: 138px;
	text-decoration: underline;
	cursor: pointer;
	&:hover {
		color:  var(--base-green);
		text-decoration: none;
	}
}
</style>
